module.exports = __webpack_public_path__ + "img/2023_FR.ae6304c8.png";